export default __webpack_public_path__ + "static/media/default_profile.72874bd6.png";